// extracted by mini-css-extract-plugin
module.exports = {"container":"QrCode_container__0e4cI","text":"QrCode_text__ZXZqw"};